import React from "react";
import AccentReadOnlyCheckbox from "../../../../../../../common/FormFields/AccentReadOnlyCheckbox";
import HeadingComponent from "../../HeadingComponent";
import HtmlOrPlainShortDescription from "../../HtmlOrPlainShortDescription";
import { parseAuditedChildOrdinalFromHeading } from "../../../../utils/sectionDisplayOrdinal";

const Video = ({
  content,
  globalCount,
  heading,
  treepath,
  showCheckbox,
  isChecked,
  onCheckboxChange,
  disabled = false,
  readOnlyCheckboxTitleMatch = null,
}) => {
  const auditBarVideoN =
    readOnlyCheckboxTitleMatch?.kind === "video" &&
    readOnlyCheckboxTitleMatch.n != null &&
    !Number.isNaN(Number(readOnlyCheckboxTitleMatch.n))
      ? Number(readOnlyCheckboxTitleMatch.n)
      : null;
  const displayHeading = (() => {
    if (auditBarVideoN != null && isChecked) {
      return `Video ${auditBarVideoN}`;
    }
    if (typeof heading === "string" && /^Video\s+\d+/i.test(heading.trim())) {
      return heading.trim();
    }
    if (globalCount != null && !Number.isNaN(Number(globalCount))) {
      return `Video ${globalCount}`;
    }
    if (typeof heading === "string" && heading.trim()) return heading.trim();
    return "Video";
  })();
  const ordinalForHighlight =
    auditBarVideoN != null && isChecked
      ? auditBarVideoN
      : parseAuditedChildOrdinalFromHeading(heading, "video") ??
        (globalCount != null && !Number.isNaN(Number(globalCount)) ? Number(globalCount) : null);
  const emphasizeReadOnlyCheckbox =
    disabled &&
    readOnlyCheckboxTitleMatch?.kind === "video" &&
    ordinalForHighlight != null &&
    Number(readOnlyCheckboxTitleMatch.n) === Number(ordinalForHighlight) &&
    (isChecked || false);

  // Get video URL from various possible fields
  const videoUrl = content.video || content.video_http_url || content.video_url;

  return (
    <div style={{ marginTop: "20px", marginBottom:"20px" }} className="header-spacing">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {showCheckbox &&
          (disabled ? (
            <AccentReadOnlyCheckbox
              readOnlyVisual
              emphasizeChecked={emphasizeReadOnlyCheckbox}
              checked={isChecked || false}
            />
          ) : (
            <input
              type="checkbox"
              checked={isChecked || false}
              onChange={onCheckboxChange}
              style={{
                width: "18px",
                height: "18px",
                cursor: "pointer",
                flexShrink: 0,
              }}
            />
          ))}
        <div style={{ flex: 1, width: "100%", minWidth: 0 }}>
          <HeadingComponent heading={displayHeading} treepath={treepath} />
        </div>
      </div>
      
      {/* Render video element if video URL is available */}
      {videoUrl && (
        <video
          controls
          style={{ width: "100%", marginTop: "10px", height: "400px" }}
          src={videoUrl}
        >
          Your browser does not support the video tag.
        </video>
      )}
      
      {/* Display video_url text if available and different from video source */}
      {(content.video_url && content.video_url !== videoUrl) && (
        <div style={{ marginTop: "10px" }}>
          {content.video_url}
        </div>
      )}
      
      <HtmlOrPlainShortDescription
        value={content.short_description}
        style={{ marginTop: videoUrl ? "10px" : "0" }}
      />
    </div>
  );
};

export default Video;
